import { CompanyFragment } from '@cycle-app/graphql-codegen';
import { SelectOption, CompanyLogo } from '@cycle-app/ui';

export const getCompanyOption = (company: CompanyFragment): SelectOption => ({
  value: company.id,
  label: company.name ?? '',
  icon: <CompanyLogo size="S" company={company} />,
});
